import { DateTime } from 'luxon';
import { z } from 'zod';

export const SUMMARY_MAX_GENERATION_RUNS = 5;
export const SUMMARY_GENERATION_LEASE_MINUTES = 10;
export const summaryGenerationStateSchema = z.enum([
  'retry',
  'in_flight',
  'quarantined',
  'completed',
]);
export const summaryGenerationFailureSchema = z.enum([
  'non_json',
  'schema',
  'guard',
  'provider',
  'abandoned',
]);
export type SummaryGenerationState = z.infer<typeof summaryGenerationStateSchema>;
export type SummaryGenerationFailure = z.infer<typeof summaryGenerationFailureSchema>;

/** A generation run already includes the content engine's bounded correction/retry calls. */
export function summaryRetryAt(attempt: number, failedAt: Date): Date | null {
  if (!Number.isInteger(attempt) || attempt < 1 || attempt > SUMMARY_MAX_GENERATION_RUNS)
    throw new Error('Invalid summary generation attempt');
  const minutes = [15, 60, 240, 1440][attempt - 1];
  return minutes === undefined
    ? null
    : DateTime.fromJSDate(failedAt, { zone: 'utc' }).plus({ minutes }).toJSDate();
}

export const summaryReplayRequestSchema = z
  .object({
    conversationId: z.uuid(),
    requestId: z.uuid(),
    expectedCycle: z.number().int().nonnegative(),
    incidentRef: z
      .string()
      .max(256)
      .regex(/^(?:[A-Z][A-Z0-9]*-\d+|https:\/\/github\.com\/quitgenius\/galapagos\/issues\/\d+)$/),
    requestedBy: z
      .string()
      .max(2048)
      .regex(/^arn:aws(?:-[a-z]+)?:[a-z0-9-]+::\d{12}:[A-Za-z0-9_+=,.@/:-]+$/),
  })
  .strict();
export type SummaryReplayRequest = z.infer<typeof summaryReplayRequestSchema>;
